<template>
  <div class="banner-form">
    <CarrosselBanner />
    <div class="container custom-container">
      <div class="banner-form--form">
        <p class="form--title">
          Peça de onde estiver e pague apenas na entrega!
        </p>
        <div class="form--row">
          <div class="form--col">
            <div class="form--img-input">
              <span class="icon icon-location form--img"></span>
              <input
                type="text"
                class="form-control"
                placeholder="Cidade"
                v-bind:value="cidade"
                @input="cidade = $event.target.value.trim()"
                autocomplete="off"
              />
            </div>
            <div
              class="sugestion-wrapper sugestion-wrapper__cidade"
              v-if="
                this.sugestCity.length != 0 ||
                  (this.sugestCity.length == 0 &&
                    this.cidade.length >= 3 &&
                    !validaCidade())
              "
            >
              <div
                class="form--sugestion"
                v-for="(item, index) in sugestCity"
                :key="index"
                @click="selectCity(item)"
              >
                <img
                  src="../assets/location-search-icon.png"
                  alt=""
                  class="form--img"
                />
                <span>{{ item.label }}</span>
              </div>
              <div
                class="form--warn"
                v-if="
                  this.sugestCity.length == 0 &&
                    this.cidade.length >= 3 &&
                    !validaCidade()
                "
              >
                <p>
                  Infelizmente o Heliar Express não se encontra disponível na
                  sua cidade.
                </p>
              </div>
            </div>
          </div>
          <div class="form--col">
            <div class="form--img-input">
              <span class="icon icon-car form--img"></span>
              <input
                type="text"
                class="form-control"
                placeholder="Modelo do carro"
                v-bind:value="carro"
                @input="carro = $event.target.value.trim()"
                @blur="toggleInsertCar()"
                @focus="toggleInsertCar()"
                autocomplete="off"
              />
            </div>
            <div
              class="sugestion-wrapper sugestion-wrapper__carro"
              v-if="this.sugestCar.length != 0 && this.insertCar"
            >
              <!-- <div class="sugestion-wrapper sugestion-wrapper__carro"> -->
              <div
                class="form--sugestion form--sugestion__car"
                v-for="(item, index) in sugestCar"
                :key="index"
                @click="selectCar(item)"
              >
                <img
                  :src="urlMarcas + item.codigo + '/' + item.arquivo"
                  alt=""
                  class="form--img"
                />
                <span>{{ item.modelo }}</span>
                <p>{{ item.ano }}</p>
              </div>
            </div>
          </div>
          <button @click="submit" class="btn banner-form--btn">
            Confira os preços
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarrosselBanner from './CarrosselBanner.vue';
/* eslint-disable no-undef */
/* eslint-disable no-useless-escape*/
export default {
  components: { CarrosselBanner },
  name: "bannerForm",
  data() {
    return {
      cidade: "",
      carro: "",
      trocaOficina: "",
      cidades: [],
      carros: [],
      preenchido: false,
      insertCar: false,
      urlMarcas:
        process.env.NODE_ENV == "production"
          ? "/arquivos/marcas/"
          : "https://www.heliarexpress.com.br/arquivos/marcas/",
    };
  },
  created() {
    this.updateList();
  },
  computed: {
    sugestCar: function() {
      if (this.carro.length >= 2) {
        var car = this.escapeCharacter(this.carro)
          .split(" ")
          .map((item) => {
            return new RegExp(item, "i");
          });
        var fullCar = new RegExp(
          "^" + this.escapeCharacter(this.carro) + "$",
          "i"
        );
        return this.carros.filter((carro) => {
          return (
            car.reduce((acc, item) => {
              return (
                acc &&
                item.test(carro.marca + " " + carro.modelo + " - " + carro.ano)
              );
            }, true) &&
            !fullCar.test(carro.modelo + " - " + carro.ano) &&
            this.carro != ""
          );
        });
      } else {
        return [];
      }
    },
    sugestCity: function() {
      if (this.cidade.length >= 2) {
        var city = new RegExp(
          this.escapeCharacter(this.removeAcento(this.cidade)),
          "i"
        );
        var fullCity = new RegExp(
          "^" + this.escapeCharacter(this.cidade) + "$",
          "i"
        );
        return this.cidades.filter((item) => {
          return (
            city.test(item.value) &&
            !fullCity.test(item.label) &&
            this.cidade != ""
          );
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    updateList() {
      $.ajax({
        // url: process.env.NODE_ENV=='production'?'./api/PrimeiraEtapa':"http://testeheliarexpress.servicos.ws/api/PrimeiraEtapa",
        url:
          process.env.NODE_ENV == "production"
            ? "./api/PrimeiraEtapa"
            : "https://www2.heliarexpress.com.br/api/PrimeiraEtapa",
        type: "GET",
        success: (response) => {
          this.cidades = response.cidades;
          this.carros = response.carros;
          if (
            sessionStorage.getItem("cidade") != null &&
            sessionStorage.getItem("carro") != null &&
            sessionStorage.getItem("cidade") != "" &&
            sessionStorage.getItem("carro") != ""
          ) {
            this.cidade = sessionStorage.getItem("cidade");
            this.carro = sessionStorage.getItem("carro");
            this.submit();
          } else {
            this.preenchido = false;
            this.carro = "";
            this.cidade = "";
          }
        },
        error: () => {
          swal
            .fire({
              title: "Ops",
              text: "Algo deu errado e a página será atualizada",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            })
            .then(() => {
              window.location.reload();
            });
        },
      });
    },
    submit() {
      var errorText = "";
      if (this.carro == "" && this.cidade == "") {
        errorText = "Escolha uma cidade e um carro.";
      } else if (this.carro == "") {
        errorText = "Escolha um carro.";
      } else if (this.cidade == "") {
        errorText = "Escolha uma cidade.";
      } else if (!this.validaCarro() && !this.validaCidade()) {
        errorText = "Escolha uma cidade e um carro válidos.";
      } else if (!this.validaCarro()) {
        errorText = "Escolha um carro válido.";
      } else if (!this.validaCidade()) {
        errorText = "Escolha uma cidade válida.";
      } else {
        $.ajax({
          // url: process.env.NODE_ENV=='production'?'./api/PrimeiraEtapa/ValidaExistenciaBateria?carro=' + encodeURIComponent(this.carro) + '&cidadeEstado=' + encodeURIComponent(this.cidade):"http://testeheliarexpress.servicos.ws/api/PrimeiraEtapa/ValidaExistenciaBateria?carro=" + encodeURIComponent(this.carro) + "&cidadeEstado=" + encodeURIComponent(this.cidade),
          url:
            process.env.NODE_ENV == "production"
              ? "./api/PrimeiraEtapa/ValidaExistenciaBateria?carro=" +
                encodeURIComponent(this.carro) +
                "&cidadeEstado=" +
                encodeURIComponent(this.cidade)
              : "https://www2.heliarexpress.com.br/api/PrimeiraEtapa/ValidaExistenciaBateria?carro=" +
                encodeURIComponent(this.carro) +
                "&cidadeEstado=" +
                encodeURIComponent(this.cidade),
          type: "GET",
          success: (response) => {
            if (response.PossuiBaterias == true) {
              if (this.trocaOficina) {
                Swal.fire({
                  title: "Aviso",
                  text:
                    "O veículo selecionado requer um processo especial para a instalação da bateria, portanto é recomendado que a troca seja feita em uma loja física.",
                  icon: "info",
                  showCancelButton: true,
                  showCloseButton: true,
                  confirmButtonText: "Ver lojas próximas",
                  cancelButtonText: "Cancelar",
                  confirmButtonColor: "#1ED760",
                  cancelButtonColor: "#13280B",
                  iconColor: "#1ED760",
                  color: "#3C3C3B",
                  background: "#EDEDED",
                }).then((result) => {
                  if (result.value) {
                    window.location.href =
                      "https://www.heliar.com.br/pt-br/onde-comprar?country=BR&state=" +
                      encodeURIComponent(this.cidade.split("-")[1].trim()) +
                      "&city=" +
                      encodeURIComponent(this.cidade.split("-")[0].trim());
                    this.cidade = "";
                    this.carro = "";
                    sessionStorage.setItem("cidade", "");
                    sessionStorage.setItem("carro", "");
                  }
                });
              } else {
                sessionStorage.setItem("cidade", this.cidade);
                sessionStorage.setItem("carro", this.carro);
                this.preenchido = true;
                this.$emit("concluido", [this.cidade, this.carro]);
              }
            } else {
              window.swal.fire({
                title: "Ops",
                text:
                  "Não foram encontradas baterias para o seu carro na cidade escolhida.",
                icon: "warning",
                iconColor: "#1ED760",
                color: "#3C3C3B",
                confirmButtonColor: "#1ED760",
                background: "#EDEDED",
                confirmButtonText: "Ok",
              });
              this.$emit("retrocede_etapa");
            }
          },
          error: () => {
            swal.fire({
              title: "Ops",
              text: "Algo deu errado, tente novamente ou atualize a página",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            });
            this.$emit("retrocede_etapa");
          },
        });
      }
      if (errorText) {
        window.swal.fire({
          title: "Ops",
          text: errorText,
          icon: "warning",
          iconColor: "#1ED760",
          color: "#3C3C3B",
          confirmButtonColor: "#1ED760",
          background: "#EDEDED",
          confirmButtonText: "Ok",
        });
        this.$emit("retrocede_etapa");
      }
    },
    selectCar(carro) {
      this.carro = carro.modelo + " - " + carro.ano;
      this.trocaOficina = carro.trocaOficina;
    },
    selectCity(cidade) {
      this.cidade = cidade.label;
    },
    validaCidade() {
      var cidReg = new RegExp(
        "^" + this.escapeCharacter(this.cidade) + "$",
        "i"
      );
      return this.cidades.some((item) => {
        return cidReg.test(item.label);
      });
    },
    validaCarro() {
      var carReg = new RegExp(
        "^" + this.escapeCharacter(this.carro) + "$",
        "i"
      );
      return this.carros.some((item) => {
        return carReg.test(item.modelo + " - " + item.ano);
      });
    },
    escapeCharacter(palavra) {
      return palavra
        .replace(/\\/g, "")
        .replace(/\[/g, "\\[")
        .replace(/\]/g, "\\]")
        .replace(/\^/g, "\\^")
        .replace(/\$/g, "\\$")
        .replace(/\./g, "\\.")
        .replace(/\|/g, "\\|")
        .replace(/\?/g, "\\?")
        .replace(/\*/g, "\\*")
        .replace(/\+/g, "\\+")
        .replace(/\(/g, "\\(")
        .replace(/\)/g, "\\)")
        .replace(/\{/g, "\\{")
        .replace(/\}/g, "\\}");
    },
    removeAcento(palavra) {
      return palavra
        .replace(/á|Á|ã|Ã|â|Â|à|À|ä|Ä/g, "a")
        .replace(/ç|Ç/g, "c")
        .replace(/é|É|ê|Ê|è|È|ë|Ë/g, "e")
        .replace(/í|Í|ì|Ì|ï|Ï|î|Î/g, "i")
        .replace(/ó|Ó|ò|Ò|ö|Ö|õ|Õ/g, "o")
        .replace(/ú|Ú|ù|Ù|ü|Ü|û|Û/g, "u")
        .replace(/Ñ|ñ/g, "n")
        .replace(/ý|Ý/g, "y");
    },
    toggleInsertCar() {
      setTimeout(() => {
        this.insertCar = !this.insertCar;
      }, 200);
    },
  },
};
</script>

<style lang="scss">
.banner-form {
  color: $cinza-escuro;
  padding-top: 28px;
  .sugestion-wrapper {
    background-color: $white;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    margin-top: 1px;
    padding: 16px;
    position: absolute;
    top: 100%;
    width: 100%;
    &__carro {
      max-height: 345px;
      overflow: auto;
      z-index: 2;
      &::-webkit-scrollbar {
        width: 18px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $cinza-escuro;
        border: 6px solid transparent;
        border-radius: 70px;
        background-clip: padding-box;
      }
    }
    &__cidade {
      max-height: 250px;
      overflow: auto;
      z-index: 3;
      &::-webkit-scrollbar {
        width: 18px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $cinza-escuro;
        border: 6px solid transparent;
        border-radius: 70px;
        background-clip: padding-box;
      }
    }
  }
  &--form {
    position: relative;
    z-index: 1;
    margin-left: auto;
    margin-right: auto;
    margin-top: -48px;
    padding: 35px;
    background-color: $second-bg-color;
    width: calc(100% - 100px);
    border-radius: 7px;
    .form {
      &--title {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 29px;
        text-align: center;
        line-height: normal;
        margin-bottom: 50px;
      }
      &--row {
        display: flex;
        justify-content: center;
        align-items: flex-start;
      }
      &--col {
        display: flex;
        flex-direction: column;
        margin-right: 28px;
        position: relative;
        flex-grow: 1;
      }
      &--img-input {
        position: relative;
        &::after {
          content: "\79";
          font-family: "heliar-express" !important;
          font-style: normal !important;
          font-weight: normal !important;
          font-variant: normal !important;
          text-transform: none !important;
          speak: none;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          position: absolute;
          top: 50%;
          right: 20px;
          font-size: 10px;
          line-height: 0;
        }
        .form-control {
          height: 54px;
          padding-left: 45px;
          padding-right: 45px;
          background: transparent;
          margin: 0 auto;
          width: 100%;
          border-radius: 5px;
          border: 1px solid #d9d9d9;
          font-size: 15px;
          padding-bottom: 0;
          padding-top: 0;
          &::placeholder {
            color: $cinza-escuro;
          }
          &:focus {
            box-shadow: none;
            color: inherit;
          }
        }
      }
      &--img {
        position: absolute;
        top: 18px;
        left: 14px;
        font-size: 19px;
        line-height: 0;
        color: $verde-heliar;
        max-width: 35px;
      }
      &--sugestion {
        position: relative;
        background-color: $white;
        min-height: 15px;
        padding-left: 50px;
        color: $cinza-escuro;
        cursor: pointer;
        span {
          font-size: 22px;
        }
        p {
          font-size: 16px;
          margin: 0;
        }
        &:not(:first-child) {
          border-top: 1px solid $cinza-medio;
          margin-top: 20px;
          padding-top: 20px;
          .form--img {
            top: 20px;
          }
        }
        .form--img {
          top: 0;
          left: 0;
          width: 25px;
        }
        &__car {
          .form--img {
            top: 10px;
            left: 0;
            width: 50px;
          }
          span {
            font-size: 22px;
            color: $cinza-escuro;
            opacity: 0.7;
          }
        }
      }
      &--warn {
        color: $cinza-escuro;
        font-weight: bold;
        text-align: center;
        font-size: 14px;
      }
    }

    .banner-form {
      &--btn {
        background-color: $verde-heliar;
        font-weight: 700;
        padding: 16px 28px;
        font-size: 16px;
        line-height: normal;
        white-space: nowrap;
      }
    }
  }
  &--banner {
    width: 100%;
    overflow: hidden;
    border-radius: 7px;
    &__mobile {
      display: none;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
}
@media (max-width: 1600px) {
  .banner-form {
    &--form {
      width: calc(100% - 75px);
      .form {
        &--sugestion {
          span {
            font-size: 18px;
          }
          p {
            font-size: 14px;
          }
        }
      }
      .btn-yellow {
        padding: 10px;
        font-size: 16px;
      }
    }
    .sugestion-wrapper {
      &__carro {
        max-height: 295px;
      }
      &__cidade {
        max-height: 200px;
      }
    }
  }
}
@media (max-width: 1200px) {
  .banner-form {
    &--form {
      width: calc(100% - 60px);
      .banner-form {
        &--btn {
          font-size: 14px;
          padding: 16px 25px;
        }
      }
      .form {
        &--sugestion {
          padding-left: 35px;
          span {
            font-size: 14px;
          }
          p {
            font-size: 12px;
          }
        }
        &--img {
          max-width: 25px;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .banner-form {
    padding-top: 0;
    .sugestion-wrapper {
      border-radius: 15px;
    }
    &--form {
      width: 100%;
      margin-top: -82px;
      border-radius: 15px;
      padding: 42px 42px 28px 42px;
      .banner-form {
        &--btn {
          font-size: 36px;
          padding: 26px 0px;
          width: 100%;
          text-align: center;
          border-radius: 15px;
        }
      }
      .form {
        &--sugestion {
          padding-left: 50px;
          &:not(:first-child) {
            .form {
              &--img {
                top: 30px;
              }
            }
          }
          span {
            font-size: 31px;
          }
          p {
            font-size: 27px;
          }
          .form {
            &--img {
              top: 8px;
              max-width: 35px;
            }
          }
        }
        &--title {
          font-size: 36px;
          margin-bottom: 35px;
        }
        &--row {
          flex-wrap: wrap;
        }
        &--col {
          flex-basis: 100%;
          margin-right: 0;
          margin-bottom: 29px;
          .form-control {
            border-radius: 15px;
            height: 99px;
            font-size: 28px;
          }
        }
        &--img {
          font-size: 32px;
          top: 34px;
        }
        &--img-input {
          .form-control {
            padding-left: 70px;
            padding-right: 70px;
            font-size: 28px;
            border-radius: 25px;
          }
          &::after {
            font-size: 24px;
          }
        }
      }
    }
    &--banner {
      display: none;
      &__mobile {
        display: block;
        border-radius: 0;
      }
    }
  }
}
@media (max-width: 767px) {
  .banner-form {
    &--form {
      .banner-form {
        &--btn {
          font-size: 32px;
        }
      }
      .form {
        &--title {
          font-size: 34px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .banner-form {
    &--form {
      margin-top: -60px;
      padding: 36px 36px 22px 36px;
      .banner-form {
        &--btn {
          font-size: 20px;
        }
      }
      .form {
        &--title {
          font-size: 22px;
        }
        &--img-input {
          .form-control {
            padding-left: 35px;
            padding-right: 35px;
            font-size: 16px;
            height: 60px;
            border-radius: 15px;
          }
          &::after {
            font-size: 16px;
            right: 10px;
          }
        }
        &--img {
          font-size: 16px;
          left: 10px;
          top: 23px;
        }
        &--sugestion {
          padding-left: 35px;
          span {
            font-size: 16px;
          }
          p {
            font-size: 14px;
          }
          .form {
            &--img {
              max-width: 20px;
              top: 0;
            }
          }
          &:not(:first-child) {
            .form {
              &--img {
                top: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
